import React, { useState, useCallback } from "react";
import {
  Drawer,
  Typography,
  Button,
  CircularProgress,
  Divider,
  Box,
} from "@material-ui/core";
import clsx from "clsx";
import { useStyles } from "./NotesDrawer.styles";
import useNotesContext from "../../../hooks/useNotesContext";
import useNotesPermissions from "../../../hooks/useNotesPermissions";
import NotesList from "../NotesList/NotesList";
import AddNoteForm from "../AddNoteForm/AddNoteForm";

const NotesDrawer = ({ open, onClose }) => {
  const classes = useStyles();
  const { notes, isLoading, error } = useNotesContext();
  const permissions = useNotesPermissions();
  const [isAdding, setIsAdding] = useState(false);

  const handleRetry = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Drawer
      className={clsx("drawer")}
      anchor="right"
      variant="temporary"
      open={open}
      onClose={onClose}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <div className={classes.container}>
        <div className={classes.header}>
          <Typography variant="h5" color="primary" component="h2">
            Notes
          </Typography>
        </div>
        <Divider />

        <div className={classes.content}>
          {isAdding && (
            <Box mb={2}>
              <AddNoteForm onCancel={() => setIsAdding(false)} />
            </Box>
          )}

          {isLoading && (
            <Box display="flex" justifyContent="center" py={4}>
              <CircularProgress data-testid="loading-spinner" />
            </Box>
          )}

          {error && !isLoading && (
            <div className={classes.errorContainer}>
              <Typography color="error" gutterBottom>
                {error}
              </Typography>
              <Button variant="outlined" onClick={handleRetry} data-testid="retry-button">
                Retry
              </Button>
            </div>
          )}

          {!isLoading && !error && (
            <NotesList notes={notes} />
          )}
        </div>

        <Divider />
        <div className={classes.footer}>
          <Button
            variant="contained"
            onClick={onClose}
            data-testid="close-button"
          >
            Close
          </Button>
          {permissions.canEdit && !isAdding && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => setIsAdding(true)}
              data-testid="add-note-button"
            >
              Add Note
            </Button>
          )}
        </div>
      </div>
    </Drawer>
  );
};

export default NotesDrawer;
